// src/hooks/useToast.js
import { useDispatch, useSelector } from 'react-redux';
import { showToast, hideToast } from '../store/uiSlice.js';

export const useToast = () => {
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.ui.toast);

  const show = (message, type = 'info') => {
    dispatch(showToast({ message, type }));
  };

  const hide = () => {
    dispatch(hideToast());
  };

  const success = (message) => show(message, 'success');
  const error = (message) => show(message, 'error');
  const warning = (message) => show(message, 'warning');
  const info = (message) => show(message, 'info');

  return {
    toast,
    show,
    hide,
    success,
    error,
    warning,
    info,
  };
};